module.exports = __webpack_public_path__ + "b05e43cd68e148d664c95750407b40ba.svg";